import {ElementDto} from "../../../../common/apis/element/ElementDto";
import {ConnectableConceptInfoDto} from "../../../../common/apis/relationship/ConnectableConceptInfoDto";
import {ArchimateElement} from "../../../../common/archimate/ArchimateElement";

export function formatElement(pickedElement: ElementDto | ConnectableConceptInfoDto | undefined | null): string {
    if (!pickedElement) {
        return "";
    } else if (!pickedElement.name) {
        return "[" + pickedElement.identifier + "]";
    } else {
        return pickedElement.name + " [" + pickedElement.identifier + "]";
    }
}

export function formatElementType(standardTypeName: string | undefined | null): string {
    if (!standardTypeName) {
        return "";
    }
    return ArchimateElement.findByStandardName(standardTypeName)?.visibleName ?? "";
}